import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import Auth from "./views/Auth.vue";
import Execute from "./views/Execute.vue";
import ExecuteList from "./views/ExecuteList.vue";
import NewTestCase from "./views/NewTestCase.vue";
import Projects from "./views/Projects.vue";
import TestCases from "./views/TestCases.vue";

import { ui, providers } from "./fire/auth";

import store from "./store";

Vue.use(Router);

const clearParams = function(to: any, from: any, next: any) {
  if (window.location.search) {
    window.history.replaceState({}, "", "/");
  }
  next();
};

const router = new Router({
  // mode: "history", // incompatible with static hosting
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "root",
      component: Home,
      beforeEnter: clearParams
    },
    {
      path: "/auth",
      name: "auth",
      component: Auth,
      props: route => ({
        uiApp: ui,
        signInOptions: providers
      })
    },
    {
      path: "/testcases",
      name: "testCases",
      component: TestCases,
      meta: { requiresAuth: true }
    },
    {
      path: "/projects",
      name: "projects",
      component: Projects,
      meta: { requiresAuth: true }
    },
    {
      path: "/new",
      name: "new",
      component: NewTestCase,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: "/execute",
      name: "execute",
      component: ExecuteList,
      meta: { requiresAuth: true }
    },
    {
      path: "/execute/:id",
      name: "executeOne",
      component: Execute,
      props: true,
      meta: { requiresAuth: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    !store.state.user
  ) {
    next({ name: "root" });
  } else if (
    store.state.user &&
    store.state.projects.length == 0 &&
    to.name != "projects"
  ) {
    next({ name: "projects" });
  } else {
    next();
  }
});

export default router;
